'use client'

import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

import { useAuth } from '../contexts/AuthContext'
import { flagId, isEnabled } from '../lib/flags'
import { VISITOR_COOKIE } from '../lib/visitor-id'

// useFlag('checkout_status_retry'): whether this person gets a feature flag's new behaviour (src/lib/flags.js says
// how they are placed; promptchan-backend docs/workflows/feature-flags.md says when to use one).
//
// False until it is known: on the server, on the first render, until sign-in has resolved (so a signed-in person is
// never placed by their visitor id first) and until the flags are read. So render today's behaviour by default and
// the new one when this is true; a flag on an action (a click, a submit) or on a screen that already waits for data
// never shows the switch.
//
// `ask` (default true): false holds off asking, so a component mounted on every visit but used by few (a modal) asks
// only when it is used, and a page that must ask the backend nothing it needn't (Create, signed out) doesn't.
export default function useFlag(flag, ask = true) {
  const { user, authResolved } = useAuth() || {}
  const id = authResolved
    ? flagId(user?.uid, Cookies.get(VISITOR_COOKIE))
    : undefined
  const [on, setOn] = useState(false)

  useEffect(() => {
    if (id === undefined || !ask) return undefined
    let current = true
    isEnabled(flag, id).then((value) => {
      if (current) setOn(value)
    })
    return () => {
      current = false
    }
  }, [flag, id, ask])

  return on
}
